import type { TaskStatus } from "@api/types";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { snoozedUntilLabel, TASK_STATUS_LABELS } from "./shared";

/** Indicator dot colors per status (design.md status-dot badge pattern). */
export const TASK_STATUS_DOTS: Record<TaskStatus, string> = {
  todo: "bg-blue-500",
  in_progress: "bg-yellow-500",
  snoozed: "bg-slate-400",
  completed: "bg-green-500",
};

export function TaskStatusBadge({
  status,
  snoozedUntil,
  className,
}: {
  status: TaskStatus;
  /** When set (and status is snoozed), the badge shows the wake date */
  snoozedUntil?: string;
  className?: string;
}) {
  const label =
    status === "snoozed" && snoozedUntil
      ? snoozedUntilLabel(snoozedUntil)
      : TASK_STATUS_LABELS[status];

  return (
    <Badge variant="outline" className={cn("max-w-full whitespace-nowrap font-medium", className)}>
      <div className={cn("size-1.5 mr-2 shrink-0 rounded-full", TASK_STATUS_DOTS[status])} />
      <span className="truncate">{label}</span>
    </Badge>
  );
}
